import { Injectable } from '@angular/core';

@Injectable({
  providedIn:'root'
})
export class Register {

   public companyName?: string;
   public name? : string;
   public mobile? : string;
   public email? : string;
   public password? : string;
   public reEnterPassword? : string;
   public Id? : number;
   public website?:string;
   public registered?:boolean;

   constructor() {}

   getCompanyName() {
      return this.companyName;
   }
   getName() {
         return this.name;
      }
   getMobile() {
      return this.mobile;
   }
   getEmail() {
      return this.email;
   }
   getPassword() {
         return this.password;
      }
   getReEnterPassword() {
      return this.reEnterPassword;
   }
     getId() {
         return this.Id;
      }
   setCompanyName(companyName : string) {
      this.companyName = companyName;
   }
   setName(name : string) {
         this.name = name;
      }
   setMobile(mobile : string) {
      this.mobile = mobile;
   }
   setEmail(email : string) {
      this.email = email;
   }

   setPassword(password : string) {
         this.password = password;
      }

   setReEnterPassword(rep : string) {
         this.reEnterPassword = rep;
   }

   setId(id : number) {
       this.Id = id;
   }
}
